import type { Tables } from '@/types/database'

type TaskLike = Pick<
  Tables<'tasks'>,
  | 'tipo'
  | 'description'
  | 'audience'
  | 'channel'
  | 'format'
  | 'approver_id'
  | 'requested_due_date'
  | 'agreed_due_date'
>

interface BriefingCheck {
  key: string
  label: string
  ok: (t: TaskLike) => boolean
}

/**
 * Um briefing de copy é completo quando traz: objetivo/informações, público,
 * canal, formato, prazo e aprovador. Base: seção "Fluxos" do escopo.
 */
const CHECKS: BriefingCheck[] = [
  { key: 'informacoes', label: 'Objetivo / informações', ok: (t) => !!t.description?.trim() },
  { key: 'publico', label: 'Público', ok: (t) => !!t.audience?.trim() },
  { key: 'canal', label: 'Canal', ok: (t) => !!t.channel?.trim() },
  { key: 'formato', label: 'Formato', ok: (t) => !!t.format?.trim() },
  { key: 'prazo', label: 'Prazo', ok: (t) => !!(t.requested_due_date || t.agreed_due_date) },
  { key: 'aprovador', label: 'Aprovador', ok: (t) => !!t.approver_id },
]

/** Só sinaliza para solicitações de copy/campanha. */
export function briefingApplies(tipo: Tables<'tasks'>['tipo']): boolean {
  return tipo === 'copy_revisao' || tipo === 'campanha'
}

export function missingBriefingFields(task: TaskLike): string[] {
  if (!briefingApplies(task.tipo)) return []
  return CHECKS.filter((c) => !c.ok(task)).map((c) => c.label)
}

export function isBriefingIncomplete(task: TaskLike): boolean {
  return missingBriefingFields(task).length > 0
}
